export class QRChip {
  hierarchy!: string;
  size!: number;
  isCleanButtonVisible?: boolean = false;
  icon?: string;
  // Jerarquía
  public static readonly HIERARCHY_2 = 'hierarchy-2';
  public static readonly HIERARCHY_3 = 'hierarchy-3';
  // Tamaños
  public static readonly SIZE_SMALL = 32;
}
